
export default class LatLng {
  constructor(private readonly _lat: number, private readonly _lng: number){
  }

  get lat(): number {
    return this._lat;
  }

  get lng(): number {
    return this._lng;
  }
}
